export { default as masthead } from './modules/masthead.js';
export { default as flyout } from './modules/flyout.js';
export { default as AlertBanner } from './modules/alert-banner.js';
export { SectionNav } from './modules/section-nav.js';
export * as share from './modules/share.js';
export * as links from './modules/links.js';
export * as fitvid from './modules/fitvid.js';
export * as fetch from './modules/fetch.js';

export const blocks = {}; // this is necessary for webpack's export modules - see webpack.config.js
